<div class="modal-header d-flex  justify-content-between">
    <h5 class="modal-title">Adressebog</h5>

    <button (click)="modal.close()" type="button" class="btn btn-sm btn-danger" data-dismiss="modal" aria-label="Close">
        <span aria-hidden="true">&times;</span>
    </button>
</div>

<div class="modal-body">


    <div class="shipment-address-picker">

        <button (click)="selectedAddress = null" class="btn btn-sm btn-outline-secondary mb-3" *ngIf="selectedAddress">
            <i class="fas fa-arrow-left"></i> Back
        </button>

        <div class="d-flex flex-wrap gap-2 align-items-center mb-3" *ngIf="!selectedAddress">
            <input
                    type="text"
                    class="form-control form-control-sm flex-grow-1"
                    placeholder="Search addresses"
                    [(ngModel)]="searchTerm"
            >
            <button type="button" class="btn btn-sm btn-primary" (click)="addAddress()">Add address</button>
        </div>

        <div class="row g-3">
            <div class="col-lg-12" *ngIf="!selectedAddress">
                <div *ngIf="filteredAddresses.length === 0" class="text-muted small">No addresses yet.</div>
                <ul *ngIf="filteredAddresses.length > 0" class="list-group">
                    <li
                            *ngFor="let address of filteredAddresses; trackBy: trackByAddress"
                            class="list-group-item address-item"
                            [class.active]="address === selectedAddress"
                            (click)="selectAddress(address)"
                    >
                        <div class="text-uppercase small text-muted">{{ address.address_type || 'receiver' }}</div>
                        <div class="fw-semibold">
                            {{ address.name_1_receiver || 'Unnamed recipient' }}
                        </div>
                        <div class="small text-muted">
                            {{ address.adress_1_receiver }}
                            <span *ngIf="address.postal_code_receiver">, {{ address.postal_code_receiver }}</span>
                            <span *ngIf="address.city_receiver"> {{ address.city_receiver }}</span>
                        </div>
                    </li>
                </ul>
            </div>

            <div class="col-lg-12" *ngIf="selectedAddress">

                <form (ngSubmit)="save()" #addressForm="ngForm" novalidate>

                    <div class="row g-2">
                        <div class="col-12">
                            <label class="form-label">Address type</label>
                            <select class="form-select form-select-sm" [(ngModel)]="selectedAddress.address_type"
                                    name="address-type"
                                    (ngModelChange)="onFieldChange()">
                                <option *ngFor="let type of addressTypes" [value]="type.value">{{ type.label }}</option>
                            </select>
                        </div>


                        <div class="col-md-6">
                            <label class="form-label">Navn 1</label>
                            <input
                                    type="text"
                                    name="name_1_receiver"
                                    class="form-control form-control-sm"
                                    [(ngModel)]="selectedAddress.name_1_receiver"
                                    (ngModelChange)="onFieldChange()"
                            >
                        </div>

                        <div class="col-md-6">
                            <label class="form-label">Navn 2</label>
                            <input
                                    type="text"
                                    name="name_2_receiver"
                                    class="form-control form-control-sm"
                                    [(ngModel)]="selectedAddress.name_2_receiver"
                                    (ngModelChange)="onFieldChange()"
                            >
                        </div>

                        <div class="col-md-6">
                            <label class="form-label">Adresse 1</label>
                            <input
                                    type="text"
                                    name="adress_1_receiver"
                                    class="form-control form-control-sm"
                                    [(ngModel)]="selectedAddress.adress_1_receiver"
                                    (ngModelChange)="onFieldChange()"
                            >
                        </div>

                        <div class="col-md-6">
                            <label class="form-label">Adresse 2</label>
                            <input
                                    type="text"
                                    name="adress_2_receiver"
                                    class="form-control form-control-sm"
                                    [(ngModel)]="selectedAddress.adress_2_receiver"
                                    (ngModelChange)="onFieldChange()"
                            >
                        </div>

                        <div class="col-md-4">
                            <label class="form-label">Postnummer</label>
                            <input
                                    type="text"
                                    name="postal_code_receiver"
                                    class="form-control form-control-sm"
                                    [(ngModel)]="selectedAddress.postal_code_receiver"
                                    (ngModelChange)="onFieldChange()"
                            >
                        </div>

                        <div class="col-md-8">
                            <label class="form-label">By</label>
                            <input
                                    type="text"
                                    name="city_receiver"
                                    class="form-control form-control-sm"
                                    [(ngModel)]="selectedAddress.city_receiver"
                                    (ngModelChange)="onFieldChange()"
                            >
                        </div>

                        <div class="col-md-4">
                            <label class="form-label">Landekode</label>
                            <select
                                    name="country_code_receiver"
                                    class="form-select"
                                    [(ngModel)]="selectedAddress.country_code_receiver"
                                    (ngModelChange)="onFieldChange()"
                            >
                                <option *ngFor="let country of shipmentsService.countries" [value]="country.code">{{ country.name }}</option>
                            </select>
                        </div>

                        <div class="col-md-4">
                            <label class="form-label">Mobil</label>
                            <input
                                    type="text"
                                    name="phone_receiver"

                                    class="form-control form-control-sm"
                                    [(ngModel)]="selectedAddress.phone_receiver"
                                    (ngModelChange)="onFieldChange()"
                            >
                        </div>

                        <div class="col-md-4">
                            <label class="form-label">Email</label>
                            <input
                                    type="email"
                                    name="email_receiver"
                                    class="form-control form-control-sm"
                                    [(ngModel)]="selectedAddress.email_receiver"
                                    (ngModelChange)="onFieldChange()"
                            >
                        </div>
                    </div>

                    <button type="submit" class="btn btn-sm btn-primary mt-3">Save</button>


                </form>


            </div>
        </div>
    </div>
</div>


<div class="modal-footer d-flex justify-content-between" *ngIf="selectedAddress">
    <a href="javascript:void(0)" (click)="deleteAddress()" class="btn btn-sm btn-danger">Delete</a>
    <button (click)="pick()" type="submit" class="btn btn-sm btn-primary">Pick</button>
</div>
